import { default as _91slug_93FNbD9oDbfEMeta } from "/opt/render/project/src/pages/[slug].vue?macro=true";
import { default as indexYy8SidDWaAMeta } from "/opt/render/project/src/pages/index.vue?macro=true";
import { default as _91slug_93ztW240kJr2Meta } from "/opt/render/project/src/pages/jobs/[slug].vue?macro=true";
export default [
  {
    name: _91slug_93FNbD9oDbfEMeta?.name ?? "slug___de___default",
    path: _91slug_93FNbD9oDbfEMeta?.path ?? "/:slug()",
    meta: _91slug_93FNbD9oDbfEMeta || {},
    alias: _91slug_93FNbD9oDbfEMeta?.alias || [],
    redirect: _91slug_93FNbD9oDbfEMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93FNbD9oDbfEMeta?.name ?? "slug___de",
    path: _91slug_93FNbD9oDbfEMeta?.path ?? "/de/:slug()",
    meta: _91slug_93FNbD9oDbfEMeta || {},
    alias: _91slug_93FNbD9oDbfEMeta?.alias || [],
    redirect: _91slug_93FNbD9oDbfEMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93FNbD9oDbfEMeta?.name ?? "slug___fr",
    path: _91slug_93FNbD9oDbfEMeta?.path ?? "/fr/:slug()",
    meta: _91slug_93FNbD9oDbfEMeta || {},
    alias: _91slug_93FNbD9oDbfEMeta?.alias || [],
    redirect: _91slug_93FNbD9oDbfEMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexYy8SidDWaAMeta?.name ?? "index___de___default",
    path: indexYy8SidDWaAMeta?.path ?? "/",
    meta: indexYy8SidDWaAMeta || {},
    alias: indexYy8SidDWaAMeta?.alias || [],
    redirect: indexYy8SidDWaAMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexYy8SidDWaAMeta?.name ?? "index___de",
    path: indexYy8SidDWaAMeta?.path ?? "/de",
    meta: indexYy8SidDWaAMeta || {},
    alias: indexYy8SidDWaAMeta?.alias || [],
    redirect: indexYy8SidDWaAMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexYy8SidDWaAMeta?.name ?? "index___fr",
    path: indexYy8SidDWaAMeta?.path ?? "/fr",
    meta: indexYy8SidDWaAMeta || {},
    alias: indexYy8SidDWaAMeta?.alias || [],
    redirect: indexYy8SidDWaAMeta?.redirect,
    component: () => import("/opt/render/project/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ztW240kJr2Meta?.name ?? "jobs-slug___de___default",
    path: _91slug_93ztW240kJr2Meta?.path ?? "/jobs/:slug()",
    meta: _91slug_93ztW240kJr2Meta || {},
    alias: _91slug_93ztW240kJr2Meta?.alias || [],
    redirect: _91slug_93ztW240kJr2Meta?.redirect,
    component: () => import("/opt/render/project/src/pages/jobs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ztW240kJr2Meta?.name ?? "jobs-slug___de",
    path: _91slug_93ztW240kJr2Meta?.path ?? "/de/jobs/:slug()",
    meta: _91slug_93ztW240kJr2Meta || {},
    alias: _91slug_93ztW240kJr2Meta?.alias || [],
    redirect: _91slug_93ztW240kJr2Meta?.redirect,
    component: () => import("/opt/render/project/src/pages/jobs/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ztW240kJr2Meta?.name ?? "jobs-slug___fr",
    path: _91slug_93ztW240kJr2Meta?.path ?? "/fr/jobs/:slug()",
    meta: _91slug_93ztW240kJr2Meta || {},
    alias: _91slug_93ztW240kJr2Meta?.alias || [],
    redirect: _91slug_93ztW240kJr2Meta?.redirect,
    component: () => import("/opt/render/project/src/pages/jobs/[slug].vue").then(m => m.default || m)
  }
]